import { Currency } from "../constants";

export interface CreatableWallet {
  currency: Currency;
  currencySymbol: string;
  name: string;
  isPrimary?: boolean;
  canDeposit: boolean;
  canWithdraw: boolean;
}

/**
 * Static allow-list of wallets a business may create.
 * Order matters — the primary wallet (NGN) is listed first.
 *
 * TODO: move this to a server route / config endpoint. For now it lives
 * client-side so the dashboard can offer wallet creation where none exist.
 */
export const creatableWallets: CreatableWallet[] = [
  {
    currency: Currency.NGN,
    currencySymbol: "₦",
    name: "Nigerian Naira",
    isPrimary: true,
    canDeposit: true,
    canWithdraw: true,
  },
  {
    currency: Currency.USD,
    currencySymbol: "$",
    name: "US Dollar",
    canDeposit: true,
    canWithdraw: false,
  },
];

/**
 * Given the wallets a business already owns, return the creatable wallets it
 * does not yet have — preserving the allow-list order (primary first).
 */
export function getMissingCreatableWallets(
  existing: Array<{ currencyCode: string }>,
): CreatableWallet[] {
  const owned = new Set(existing.map((wallet) => wallet.currencyCode));
  return creatableWallets.filter((wallet) => !owned.has(wallet.currency));
}
